import IcRemove from './IcRemove'

export default IcRemove
